module.exports = __webpack_public_path__ + "static/media/auth-bg-shapes.a7afce77.jpg";